const Lightbox = (() => {

  const DOM = {};
  const video = document.getElementById('lightbox-video');
  let player;

  const initialisePlayer = () => {
    player = new Vimeo.Player(video);
  }

  const cacheDOM = () => {
    DOM.img = document.getElementById('preview-image');
    DOM.light = document.getElementById('lightbox');
    DOM.close = document.getElementById('lightbox-close-btn');
    DOM.vid = document.getElementById('lightbox-video');
  };

  const eventListener = () => {
    DOM.img.addEventListener('click', function (e) {
      e.preventDefault();
      DOM.light.classList.add('video-show');
      DOM.close.setAttribute('tabindex', '0');
      DOM.vid.setAttribute('tabindex', '0');
    });
    DOM.close.addEventListener('click', function (e) {
      e.preventDefault();
      DOM.light.classList.remove('video-show');
      DOM.close.setAttribute('tabindex', '-1');
      DOM.vid.setAttribute('tabindex', '-1');
      player.pause()
    });
    DOM.light.addEventListener('click', function (e) {
      e.preventDefault();
      DOM.light.classList.remove('video-show');
      DOM.close.setAttribute('tabindex', '-1');
      DOM.vid.setAttribute('tabindex', '-1');
      player.pause()
    })
  };

  const init = () => {
    initialisePlayer();
    cacheDOM();
    eventListener();

  };

  return {
    init
  }
})();

export default Lightbox;
